/*
 * Project: LegalPlace assistant
 * File: src\components\control_bar.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as validator from 'validator';
import {
  setAppState, LP_STATE_CHECKOUT, LP_STATE_PAYMENT, LP_STATE_WIZARD,
} from '../redux/actions/app_state';
import { scrollAndGoUp, scrollTo } from './utils/misc';
import {redirectToSection, setIsFinished} from '../redux/actions/contract';
import { buildQuery } from '../redux/actions/checkout_operations';
import { raiseMailError, unraiseMailErrors } from '../redux/actions/error';
import { updateMailFromInput } from '../redux/actions/account_settings';
import { _lp } from '../logic/wording';
import lpApp from '../app/lp_app';
import DefaultValues from '../logic/default_values';
import History from '../logic/utils/history';
import { HARCODED_CHECKOUT_META_IDS } from '../constants/hardcoded_checkout';
import lpevents from '../tracking/lpevents';

// TODO: Add test if am on the first and last page.

class _ControlBar extends Component {
  constructor(props) {
    super(props);
    this.nextCallback = this.nextCallback.bind(this);
    this.previousCallback = this.previousCallback.bind(this);
    this.onHoverControlBarScrolling = this.onHoverControlBarScrolling.bind(this);
    this.clickNumber = 0;
    this.state = {
      isLoading: false
    };
  }

  onHoverControlBarScrolling() {
    if (window.scrollingTracker) {
      this.hoverTime = new Date().getTime();
      const wizardCoord = document.querySelector('.wizard-navbar').getBoundingClientRect();
      const controlBarCoord = document.querySelector('.wizard').getBoundingClientRect();

      const remainingSpace = 200;

      this.remainingBottomSpace = controlBarCoord.bottom - wizardCoord.bottom - 1;

      if (this.remainingBottomSpace >= remainingSpace) {
        this.scrollAnimation = scrollTo(
          document.documentElement, window.scrollY + remainingSpace, 500,
        );
      } else {
        this.scrollAnimation = scrollTo(
          document.documentElement, window.scrollY + this.remainingBottomSpace, 500,
        );
      }
    }
    return null;
  }

  nextCallback() {
    this.clickTime = new Date().getTime();
    const remainingTime = this.clickTime - this.hoverTime;
    // Raising click number
    this.clickNumber += 1;
    if (remainingTime < 1000 && this.remainingBottomSpace > 150 && this.clickNumber < 3) return;

    // Setting default values for previous sections
    DefaultValues.setDefaults();

    // Updating sections with default values
    this.props.updateSections();

    // Stopping animation and reseting click number
    if (this.scrollAnimation) this.scrollAnimation.stop();
    this.clickNumber = 0;
    if (this.props.app_state_save) {
      if (validator.isEmail(this.props.mail) || (this.props.document_unique !== '')) {
        this.props.unreaiseError();
        // saveMail(this.props.mail);
        this.props.pass0(this.props.mail, true);
        lpevents.trackGTMGAEvent('Contrat sauvegarde', 'Formulaire valide', this.props.contractTitle)
      } else {
        this.props.raiseError();
      }
      return;
    }

    // || this.props.currentSection == (this.props.max_sections - 1)
    if (this.props.app_state_mail) {
      // console.log("here is mail")
      if (validator.isEmail(this.props.mail) || (this.props.document_unique !== '')) {
        this.setState({isLoading: true})
        this.props.unreaiseError();
        // saveMail(this.props.mail);
        this.props.pass0(this.props.mail);
        this.props.setIsFinished_(true);
        lpApp.ops.contacts.registerMail(this.props.mail);
        lpApp.ops.slack.sendCustomeSlack();
        lpevents.trackGTMGAEvent('Inscription email', 'Clic', 'Funnel Contrat standard')
        //lpApp.ops.contacts.saveHubSpot();
        // debugger;
        // this.props.goDownload();
      } else {
        this.props.raiseError();
      }
      // TODO: raise the errors.
    } else {
      if (this.props.document_unique !== '') {
        if (
          this.props.currentSection === (this.props.max_sections - 1)
          && this.props.max_sections > 1
        ) {
          // TODO: (Moncef) I added the "or true" condition
          // in order to avoid the bugs caused in DEV-902 to block Mehdi from testing
          // Please, fix asap
          if (lpApp.isPayed) {
            lpApp.ops.slack.generateSendinBlue('Reached Post Payment');
            lpApp.ops.slack.generateMixpanel('Reached Post Payment')
          }
          if (
            (lpApp.ops.mandatory.globalCheckOptions() && lpApp.ops.mandatory.globalCheckVariables())
            || !lpApp.isPayed
            || true
          ) {
            lpApp.ops.slack.sendContinueMessage('Validate');
            lpApp.ops.slack.sendCustomeSlack();
            this.props.pass0(this.props.mail, false);
          }
          return;
        }
        this.props.goForward();
        return;
      }
      if (
        this.props.currentSection === (this.props.max_sections - 1)
        && this.props.max_sections > 1
      ) {
        lpApp.ops.slack.sendContinueMessage();
        this.props.goCheckout();
        return;
      }
      this.props.goForward();
    }
  }

  previousCallback() {
    // Stopping animation and reseting click number
    if (this.scrollAnimation) {
      this.scrollAnimation.stop();
    }
    this.clickNumber = 0;


    if (this.props.app_state_mail) {
      if (validator.isEmail(this.props.mail)) {
        this.props.resetMail();
        this.props.goWizard();
      } else {
        this.props.resetMail();
        this.props.goWizard();
      }
    } else if (this.props.currentSection > 0) {
      this.props.goBackward();
    }
  }

  render() {
    const validate = HARCODED_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1 ? 'validate' : 'email-download';
    const checkmark = HARCODED_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1 ? 'checkmark' : 'file-download';

    return (
      <div className="wizard-navbar">
        <div className="wizard-navbar-inner">
          {(!this.props.app_state_save)
            ? (
              <a
                className="btn btn-back new-btn-nav-wizard"
                style={!this.props.app_state_mail && (this.props.currentSection === 0) ? { color: 'grey', opacity: '0' } : {}}
                onClick={this.previousCallback}
              >
                <i className="icn-arrow-left" />
                {_lp('Précédent')}
              </a>
            ) : (
              <a
                className="btn btn-back new-btn-nav-wizard"
                onClick={() => { this.props.resetMail(); this.props.goWizard(); }}
              >
                <i className="icn-arrow-left" />
                {_lp('Revenir ')}
                {' '}
                <span className="hidden-xs">{_lp('au questionnaire')}</span>
              </a>
            )}

          {!(this.props.app_state_save && this.props.document_unique !== '') && (
          <div className="pull-right">

            <a
              className={`${(this.props.app_state_mail
                            || ((this.props.document_unique !== '')
                                && (this.props.currentSection >= (this.props.max_sections - 1)))) ? `btn btn-${validate}` : 'btn btn-next'} on${this.props.pricing_loading || this.props.checkout_loading ? ' checking' : ''}`}
              onClick={this.nextCallback}
            >
              { (this.props.app_state_mail
                            || ((this.props.document_unique !== '')
                                && (this.props.currentSection >= (this.props.max_sections - 1))))
                ? <i className={this.props.mail_icon ? 'material-icons' : `icn-${checkmark}`}>{(this.props.mail_icon && this.props.mail_icon !== 'none') ? this.props.mail_icon : ''}</i> : (this.props.app_state_save) ? <i className="icn-save" /> : <i />
                            }
              <i className="loading-spin" />
              {(this.props.app_state_mail
                            || ((this.props.document_unique !== '')
                                && (this.props.currentSection >= (this.props.max_sections - 1))))
                ? (lpApp.references.customs.get('email_section_cta') === 'NONE' ? ((lpApp.references.customs.get('duplicate_cta_email') === 'NONE') ? _lp('Télécharger') : lpApp.references.customs.get('duplicate_cta_email')) : lpApp.references.customs.get('email_section_cta'))
                : (this.props.app_state_save)
                  ? _lp('Sauvegarder')
                  : _lp('Suivant')}
              { (this.props.app_state_mail || this.props.app_state_save
                            || ((this.props.document_unique !== '')
                                && (this.props.currentSection >= (this.props.max_sections - 1))))
                ? <i /> : <i className="icn-arrow-right" />
                            }

            </a>
            {(!this.props.app_state_mail && !this.props.app_state_save && ((this.props.currentSection < (this.props.max_sections - 1)) || ((this.props.document_unique !== '') && (this.props.currentSection < (this.props.max_sections - 1))))) && <a className="btn btn-skip hidden-xs new-btn-nav-wizard" onClick={this.nextCallback}>{_lp('Passer')}</a>}
          </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  mail_icon: lpApp.references.customs.custom.email_section_cta_icon,
  currentSection: state.contract.currentSection,
  total_sections: state.contract.total_sections,
  app_state_mail: state.appstate === 1,
  app_state_save: state.appstate === 3,
  mail: state.account_settings.mail,
  contractTitle: state.contract.name,
  max_sections: Object.keys(state.contract.sections).length,
  document_unique: state.document_state.unique,
  pricing_loading: state.loading_details.checking,
  checkout_loading: state.loading_details.pricing,

});

const mapDispatchToProps = dispatch => ({
  dispatchGoDownload: () => {
    dispatch(setAppState(LP_STATE_PAYMENT));
  },
  setIsFinished_: (value) => {
    dispatch(setIsFinished(value));
  },
  dispatchGoWizard: () => {
    dispatch(setAppState(LP_STATE_WIZARD));
  },
  dispatchGoForward: (id) => {
    // check
    lpApp.mutex.setMutex('preview', false);
    dispatch(lpApp.ops.initialization.raNextInit(id - 1));
    lpApp.mutex.setMutex('preview', true);
    dispatch(redirectToSection(id));
    //dispatch(setSection(id));
    //------------------------------
    // flush options
    //------------------------------
  },
  dispatchGoBackward: (id) => {
    dispatch(redirectToSection(id));
    //dispatch(setSection(id));
    //------------------------------
    // flush options
    //------------------------------
  },
  dispatchGoCheckout: () => {
    dispatch(setAppState(LP_STATE_CHECKOUT));
    scrollAndGoUp();
  },
  pass0: (mail, save_ = false) => {
    dispatch(buildQuery(save_));
    scrollAndGoUp();
  },

  dispatchRaiseError: () => {
    dispatch(raiseMailError());
  },
  dispatchUnraiseError: () => {
    dispatch(unraiseMailErrors());
  },
  resetMail: () => {
    dispatch(updateMailFromInput(''));
  },
  autoSave: () => {
    // console.log("auto")
    dispatch(buildQuery(true, true));
  },
  dispatchUpdateSection: () => {
    dispatch({type: 'UPDATE_SECTIONS_C'});
  }
});


const mergeProps = (stateProps, dispatchProps) => ({
  mail_icon: stateProps.mail_icon,
  document_unique: stateProps.document_unique,
  mail: stateProps.mail,
  app_state_mail: stateProps.app_state_mail,
  app_state_save: stateProps.app_state_save,
  contractTitle: stateProps.contractTitle,
  currentSection: stateProps.currentSection,
  max_sections: stateProps.max_sections,
  pricing_loading: stateProps.pricing_loading,
  checkout_loading: stateProps.checkout_loading,
  goForward: () => {
    // console.log("I am in " + stateProps.currentSection);
    if (
      stateProps.max_sections === (stateProps.currentSection + 1)
      && stateProps.max_sections >= 1
    ) {
      dispatchProps.dispatchGoCheckout();
      scrollAndGoUp();
    } else {
      dispatchProps.dispatchGoForward(stateProps.currentSection + 1);
    }
    if (window.lpMax <= stateProps.currentSection + 1) {
      window.lpMax = stateProps.currentSection + 1;
    }
    scrollAndGoUp();
  },
  goBackward: () => {
    if (stateProps.currentSection !== 0) {
      dispatchProps.dispatchGoBackward(stateProps.currentSection - 1);
      scrollAndGoUp();
    }
  },
  goDownload: dispatchProps.dispatchGoDownload,
  goWizard: dispatchProps.dispatchGoWizard,
  pass0: dispatchProps.pass0,
  setIsFinished_: dispatchProps.setIsFinished_,
  raiseError: dispatchProps.dispatchRaiseError,
  unreaiseError: dispatchProps.dispatchUnraiseError,
  updateSections: dispatchProps.dispatchUpdateSection,
  resetMail: dispatchProps.resetMail,
  goCheckout: dispatchProps.dispatchGoCheckout,
  autoSave: dispatchProps.autoSave,
});

const ControlBar = connect(mapStateToProps, mapDispatchToProps, mergeProps)(_ControlBar);

export default ControlBar;



// WEBPACK FOOTER //
// ./src/components/control_bar.js